/**
 * Project: depilujma
 * Owner: depilujma
 * Lead Author: Peter Golembiovský
 * Contributors: depilujma contributors
 * Year: 2026
 * Copyright (c) 2026 depilujma. All rights reserved.
 */

const nav = document.getElementById('site-nav');
const navToggle = document.getElementById('nav-toggle');
const mobileMenu = document.getElementById('mobile-menu');
const logoTitle = document.querySelector('.nav-logo-title');
const navVariant = nav?.dataset.navVariant || 'home';
const isFabricatorNav = navVariant === 'fabricator';

function onScroll() {
    if (isFabricatorNav) {
        return;
    }

    const scrolled = window.scrollY > 50;
    if (!nav) {
        return;
    }
    if (scrolled) {
        nav.classList.add('bg-white/95', 'shadow-md', 'backdrop-blur', 'ring-1', 'ring-dm-purple-soft/30');
        nav.classList.remove('border-transparent');
        document.querySelectorAll('#site-nav a[href^="#"]').forEach((a) => {
            a.classList.remove('text-white/90');
            a.classList.add('text-dm-purple-dark', 'hover:text-dm-gold');
        });
        logoTitle?.classList.remove('text-white', 'lg:text-white');
        logoTitle?.classList.add('text-dm-purple-dark');
    } else {
        nav.classList.remove('bg-white/95', 'shadow-md', 'backdrop-blur', 'ring-1', 'ring-dm-purple-soft/30');
        document.querySelectorAll('#site-nav nav a').forEach((a) => {
            a.classList.add('text-white/90');
            a.classList.remove('text-dm-purple-dark', 'hover:text-dm-gold');
        });
        logoTitle?.classList.add('text-white', 'lg:text-white');
        logoTitle?.classList.remove('text-dm-purple-dark');
    }
}

if (!isFabricatorNav) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
}

navToggle?.addEventListener('click', () => {
    const open = mobileMenu?.classList.toggle('hidden') === false;
    navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});

document.querySelectorAll('#mobile-menu a').forEach((a) => {
    a.addEventListener('click', () => {
        mobileMenu?.classList.add('hidden');
        navToggle?.setAttribute('aria-expanded', 'false');
    });
});

document.querySelectorAll('#pricing-tabs .pricing-tab').forEach((btn) => {
    btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-tab');
        document.querySelectorAll('#pricing-tabs .pricing-tab').forEach((b) => {
            b.classList.remove('border-transparent', 'bg-linear-to-r', 'from-dm-purple', 'to-dm-purple-light', 'text-white', 'shadow-lg');
            b.classList.add('border-dm-purple-soft', 'bg-white', 'text-dm-purple-dark');
        });
        btn.classList.add('border-transparent', 'bg-linear-to-r', 'from-dm-purple', 'to-dm-purple-light', 'text-white', 'shadow-lg');
        btn.classList.remove('border-dm-purple-soft', 'bg-white', 'text-dm-purple-dark');
        document.querySelectorAll('.pricing-panel').forEach((p) => {
            p.classList.toggle('hidden', p.getAttribute('data-panel') !== id);
        });
    });
});

const galeriaSection = document.getElementById('galeria');
const galleryMoreUrl = galeriaSection?.dataset.galleryMoreUrl || '';
const galleryCinema = document.getElementById('gallery-cinema');
const galleryCinemaClose = document.getElementById('gallery-cinema-close');
const galleryCinemaTitle = document.getElementById('gallery-cinema-title');
const galleryCinemaCaption = document.getElementById('gallery-cinema-caption');
const galleryCinemaStage = document.getElementById('gallery-cinema-stage');
const galleryCinemaStageWrap = document.getElementById('gallery-cinema-stage-wrap');
const galleryCinemaStrip = document.getElementById('gallery-cinema-strip');
const galleryCinemaPrev = document.getElementById('gallery-cinema-prev');
const galleryCinemaNext = document.getElementById('gallery-cinema-next');

/** @type {{ items: object[], index: number, slug: string, categoryLabel: string, nextOffset: number, hasMore: boolean, loading: boolean } | null} */
let galleryCinemaState = null;

/** @type {HTMLElement | null} */
let galleryCinemaOpener = null;

function isGalleryCinemaOpen() {
    return Boolean(galleryCinema && !galleryCinema.classList.contains('hidden'));
}

function getGalleryCinemaFocusables() {
    if (!isGalleryCinemaOpen() || !galleryCinema) {
        return [];
    }
    const selector = [
        'a[href]:not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        'input:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'iframe',
        '[tabindex]:not([tabindex="-1"])',
    ].join(', ');
    return Array.from(galleryCinema.querySelectorAll(selector)).filter((el) => {
        if (!(el instanceof HTMLElement)) {
            return false;
        }
        if (el.getAttribute('tabindex') === '-1') {
            return false;
        }
        if (el.tagName === 'IFRAME') {
            return true;
        }
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
}

function galleryCinemaHandleTab(e) {
    const list = getGalleryCinemaFocusables();
    if (list.length === 0) {
        return;
    }
    const active = document.activeElement;
    const i = list.indexOf(active);
    if (e.shiftKey) {
        if (i <= 0) {
            e.preventDefault();
            list[list.length - 1].focus();
        }
        return;
    }
    if (i === -1 || i >= list.length - 1) {
        e.preventDefault();
        list[0].focus();
    }
}

function focusGalleryCinemaInitial() {
    queueMicrotask(() => {
        if (!isGalleryCinemaOpen()) {
            return;
        }
        galleryCinemaClose?.focus({ preventScroll: true });
    });
}

function pauseGalleryCinemaMedia() {
    galleryCinemaStage?.querySelectorAll('video').forEach((v) => v.pause());
}

function closeGalleryCinema() {
    pauseGalleryCinemaMedia();
    const opener = galleryCinemaOpener;
    galleryCinemaOpener = null;
    galleryCinemaState = null;
    if (galleryCinema) {
        galleryCinema.classList.add('hidden');
        galleryCinema.classList.remove('flex');
        galleryCinema.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    if (opener instanceof HTMLElement && document.contains(opener)) {
        opener.focus({ preventScroll: true });
    }
}

function isSelfHostedVideo(url) {
    if (!url) {
        return false;
    }
    const u = url.toLowerCase();
    return u.endsWith('.mp4') || u.endsWith('.webm') || u.endsWith('.mov') || u.includes('/storage/');
}

async function fetchGalleryPage(slug, offset) {
    const u = new URL(galleryMoreUrl, window.location.origin);
    u.searchParams.set('category', slug);
    u.searchParams.set('offset', String(offset));
    u.searchParams.set('per_page', '24');
    const res = await fetch(u.toString(), { headers: { Accept: 'application/json' } });
    if (!res.ok) {
        throw new Error('load');
    }
    return res.json();
}

function renderGalleryCinemaStage(item) {
    if (!galleryCinemaStage) {
        return;
    }
    galleryCinemaStage.innerHTML = '';
    const video = item.video_url && String(item.video_url).length ? item.video_url : null;
    if (video) {
        if (isSelfHostedVideo(video)) {
            const el = document.createElement('video');
            el.src = video;
            el.controls = true;
            el.playsInline = true;
            el.className = 'max-h-[min(70vh,100%)] max-w-full rounded-lg bg-black object-contain';
            galleryCinemaStage.appendChild(el);
        } else {
            const iframe = document.createElement('iframe');
            iframe.src = String(video).includes('youtube')
                ? String(video).replace('watch?v=', 'embed/').split('&')[0]
                : video;
            iframe.className = 'aspect-video w-full max-w-3xl rounded-lg bg-black';
            iframe.setAttribute('allowfullscreen', 'true');
            galleryCinemaStage.appendChild(iframe);
        }
    } else {
        const img = document.createElement('img');
        img.src = item.image_url;
        img.alt = item.alt_text || '';
        img.className = 'max-h-[min(70vh,100%)] max-w-full rounded-lg object-contain';
        galleryCinemaStage.appendChild(img);
    }
}

function renderGalleryCinemaStrip() {
    if (!galleryCinemaStrip || !galleryCinemaState) {
        return;
    }
    const { items, index } = galleryCinemaState;
    galleryCinemaStrip.innerHTML = '';
    items.forEach((it, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.cinemaIndex = String(i);
        btn.setAttribute('aria-label', `Položka ${i + 1} z ${items.length}`);
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        btn.className = `shrink-0 overflow-hidden rounded-lg outline-none ring-2 transition focus-visible:ring-2 focus-visible:ring-dm-gold focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950 ${i === index ? 'ring-dm-gold opacity-100' : 'ring-transparent opacity-70 hover:opacity-100'}`;
        const im = document.createElement('img');
        im.src = it.image_url;
        im.alt = '';
        im.className = 'h-16 w-24 object-cover';
        im.loading = 'lazy';
        btn.appendChild(im);
        btn.addEventListener('click', () => {
            if (!galleryCinemaState) {
                return;
            }
            galleryCinemaState.index = i;
            renderGalleryCinema();
        });
        galleryCinemaStrip.appendChild(btn);
    });
    galleryCinemaStrip.querySelector(`button[data-cinema-index="${index}"]`)?.scrollIntoView({ inline: 'center', block: 'nearest' });
}

function renderGalleryCinema() {
    if (!galleryCinemaState || !galleryCinemaTitle || !galleryCinemaCaption) {
        return;
    }
    const { items, index, categoryLabel } = galleryCinemaState;
    const item = items[index];
    if (!item) {
        return;
    }
    pauseGalleryCinemaMedia();
    galleryCinemaTitle.textContent = categoryLabel;
    const t = item.title && String(item.title).trim();
    galleryCinemaCaption.textContent = t || '\u00a0';
    renderGalleryCinemaStage(item);
    renderGalleryCinemaStrip();
}

async function loadMoreGalleryForCinema() {
    if (!galleryCinemaState) {
        return;
    }
    const { slug, nextOffset, hasMore, loading } = galleryCinemaState;
    if (!hasMore || loading) {
        return;
    }
    galleryCinemaState.loading = true;
    try {
        const data = await fetchGalleryPage(slug, nextOffset);
        galleryCinemaState.items.push(...data.items);
        galleryCinemaState.nextOffset = data.shown;
        galleryCinemaState.hasMore = data.hasMore;
    } catch {
        if (galleryCinemaCaption) {
            galleryCinemaCaption.textContent = 'Nepodarilo sa dočítať galériu.';
        }
    } finally {
        if (galleryCinemaState) {
            galleryCinemaState.loading = false;
        }
    }
}

async function galleryCinemaStep(delta) {
    if (!galleryCinemaState) {
        return;
    }
    const st = galleryCinemaState;
    let ni = st.index + delta;
    if (ni < 0) {
        st.index = st.items.length - 1;
        renderGalleryCinema();
        return;
    }
    while (ni >= st.items.length && st.hasMore) {
        const lenBefore = st.items.length;
        await loadMoreGalleryForCinema();
        if (st.items.length === lenBefore) {
            break;
        }
    }
    if (ni >= st.items.length) {
        st.index = 0;
    } else {
        st.index = ni;
    }
    renderGalleryCinema();
}

async function openGalleryCinema(slug, categoryLabel, opener) {
    if (!galleryCinema || !galleryCinemaStage || !galleryMoreUrl) {
        return;
    }
    galleryCinemaOpener = opener instanceof HTMLElement ? opener : null;
    galleryCinemaState = {
        items: [],
        index: 0,
        slug,
        categoryLabel,
        nextOffset: 0,
        hasMore: true,
        loading: false,
    };
    galleryCinema.classList.remove('hidden');
    galleryCinema.classList.add('flex');
    galleryCinema.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    focusGalleryCinemaInitial();
    if (galleryCinemaTitle) {
        galleryCinemaTitle.textContent = categoryLabel;
    }
    if (galleryCinemaCaption) {
        galleryCinemaCaption.textContent = 'Načítavam…';
    }
    galleryCinemaStage.innerHTML = '';
    if (galleryCinemaStrip) {
        galleryCinemaStrip.innerHTML = '';
    }
    try {
        const data = await fetchGalleryPage(slug, 0);
        if (!galleryCinemaState) {
            return;
        }
        galleryCinemaState.items = data.items;
        galleryCinemaState.nextOffset = data.shown;
        galleryCinemaState.hasMore = data.hasMore;
        if (!data.items.length) {
            galleryCinemaStage.innerHTML =
                '<p class="px-4 text-center text-sm text-white/80">V tejto kategórii nie sú žiadne verejné položky.</p>';
            if (galleryCinemaCaption) {
                galleryCinemaCaption.textContent = '';
            }
            return;
        }
        galleryCinemaState.index = 0;
        renderGalleryCinema();
    } catch {
        galleryCinemaStage.innerHTML = '<p class="px-4 text-center text-sm text-white/80">Obsah sa nepodarilo načítať.</p>';
        if (galleryCinemaCaption) {
            galleryCinemaCaption.textContent = '';
        }
    }
}

galleryCinemaClose?.addEventListener('click', closeGalleryCinema);

galleryCinemaPrev?.addEventListener('click', () => {
    galleryCinemaStep(-1);
});

galleryCinemaNext?.addEventListener('click', () => {
    galleryCinemaStep(1);
});

document.querySelectorAll('.gallery-category-open').forEach((btn) => {
    btn.addEventListener('click', () => {
        const slug = btn.getAttribute('data-category-slug');
        const label = btn.getAttribute('data-category-label') || '';
        if (slug) {
            openGalleryCinema(slug, label, btn);
        }
    });
});

let gallerySwipeStartX = null;
galleryCinemaStageWrap?.addEventListener(
    'touchstart',
    (e) => {
        gallerySwipeStartX = e.changedTouches[0]?.clientX ?? null;
    },
    { passive: true },
);
galleryCinemaStageWrap?.addEventListener(
    'touchend',
    (e) => {
        if (gallerySwipeStartX == null) {
            return;
        }
        const endX = e.changedTouches[0]?.clientX ?? gallerySwipeStartX;
        const dx = endX - gallerySwipeStartX;
        gallerySwipeStartX = null;
        if (Math.abs(dx) < 50) {
            return;
        }
        if (dx < 0) {
            galleryCinemaStep(1);
        } else {
            galleryCinemaStep(-1);
        }
    },
    { passive: true },
);

const slides = Array.from(document.querySelectorAll('.featured-slide'));
let slideIdx = 0;
if (slides.length) {
    setInterval(() => {
        slides[slideIdx].classList.add('pointer-events-none', 'opacity-0');
        slides[slideIdx].classList.remove('opacity-100');
        document.querySelectorAll('.featured-dot').forEach((d) => d.classList.remove('bg-dm-gold'));
        document.querySelectorAll('.featured-dot').forEach((d) => d.classList.add('bg-white/40'));
        slideIdx = (slideIdx + 1) % slides.length;
        slides[slideIdx].classList.remove('pointer-events-none', 'opacity-0');
        slides[slideIdx].classList.add('opacity-100');
        const dot = document.querySelector(`.featured-dot[data-dot="${slideIdx}"]`);
        dot?.classList.add('bg-dm-gold');
        dot?.classList.remove('bg-white/40');
    }, 4000);
}

document.querySelectorAll('.featured-dot').forEach((dot) => {
    dot.addEventListener('click', () => {
        const i = Number(dot.getAttribute('data-dot'));
        slides.forEach((s, idx) => {
            const on = idx === i;
            s.classList.toggle('opacity-100', on);
            s.classList.toggle('opacity-0', !on);
            s.classList.toggle('pointer-events-none', !on);
        });
        document.querySelectorAll('.featured-dot').forEach((d) => {
            d.classList.toggle('bg-dm-gold', d === dot);
            d.classList.toggle('bg-white/40', d !== dot);
        });
        slideIdx = i;
    });
});

document.addEventListener(
    'keydown',
    (e) => {
        if (!isGalleryCinemaOpen()) {
            return;
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            closeGalleryCinema();
            return;
        }
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            galleryCinemaStep(-1);
            return;
        }
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            galleryCinemaStep(1);
            return;
        }
        if (e.key === 'Tab') {
            galleryCinemaHandleTab(e);
        }
    },
    true,
);

const revealTargets = Array.from(document.querySelectorAll('.reveal, [data-dm-anim]'));
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (reduceMotion) {
    revealTargets.forEach((el) => el.classList.add('is-visible'));
} else if (revealTargets.length) {
    const io = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((en) => {
                if (en.isIntersecting) {
                    en.target.classList.add('is-visible');
                    observer.unobserve(en.target);
                }
            });
        },
        { threshold: 0.12 },
    );

    revealTargets.forEach((el) => {
        const delay = el.getAttribute('data-dm-anim-delay');
        if (delay === '150' || delay === '300' || delay === '500') {
            el.style.setProperty('--dm-anim-delay', `${delay}ms`);
        }
        io.observe(el);
    });
}

(function initCookieConsent() {
    const bar = document.getElementById('cookie-consent');
    if (!bar) {
        return;
    }

    const storageKey = 'dm_cookie_consent';
    const cookieName = 'dm_cookie_consent';
    const maxAgeDays = 180;

    function readStored() {
        try {
            return localStorage.getItem(storageKey);
        } catch {
            return null;
        }
    }

    function persist(choice) {
        try {
            localStorage.setItem(storageKey, choice);
        } catch {
            // ignore
        }
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `${cookieName}=${encodeURIComponent(choice)}; Path=/; Max-Age=${maxAgeDays * 86400}; SameSite=Lax${secure}`;
        bar.classList.add('hidden');
    }

    if (readStored() || document.cookie.split(';').some((c) => c.trim().startsWith(`${cookieName}=`))) {
        return;
    }

    bar.classList.remove('hidden');

    bar.querySelectorAll('[data-cookie-choice]').forEach((btn) => {
        btn.addEventListener('click', () => {
            const choice = btn.getAttribute('data-cookie-choice') || 'essential';
            persist(choice);
        });
    });
})();
